/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_BoardInputs */

const en_directory_promotion_benefits_board = /** @type {(inputs: Directory_Promotion_Benefits_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored board position`)
};

const zh_directory_promotion_benefits_board = /** @type {(inputs: Directory_Promotion_Benefits_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助榜单位置`)
};

/**
* | output |
* | --- |
* | "Sponsored board position" |
*
* @param {Directory_Promotion_Benefits_BoardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_board = /** @type {((inputs?: Directory_Promotion_Benefits_BoardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_BoardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_board(inputs)
	return zh_directory_promotion_benefits_board(inputs)
});
export { directory_promotion_benefits_board as "directory.promotion.benefits.board" }